import React from 'react';
import * as EmptyState from '@modules/Dashboard/components/EmptyState/EmptyState';
import { useOrdersEmptyStateRecommendations } from '@modules/Dashboard/modules/Recommendations';
export const OrdersEmptyStateWithRecommendations = () => {
    const { recommendations } = useOrdersEmptyStateRecommendations();
    return (React.createElement(EmptyState.Root, { title: "You haven\u2019t received any orders yet", subtitle: "Here are a few recommendations to help you get your first sales" }, recommendations && recommendations.length > 0 && (React.createElement(EmptyState.Recommendations, null, recommendations.map(({ suggestion, id }) => {
        return (React.createElement(EmptyState.Suggestion, { key: `recommendation-${id}`, "data-analytics": id }, suggestion));
    })))));
};
